import { createChunkLoader } from 'utils/chunkLoader';

// The transcript drawer and the multi-candidate chat, loaded by the candidates
// table when first opened and warmed by the boot warm-up for a deep-linked
// candidate (app-shell/routeMounts) or once the candidates page is idle. Both
// go through one loader per chunk: Vite's preload helper waits for a chunk's
// stylesheets only in the first import of it, so a second, separate import
// could render the drawer before its CSS has loaded.

export const transcriptWrapperChunk = createChunkLoader(
  () => import('./TranscriptWrapper')
);

export const transcriptChatChunk = createChunkLoader(
  () => import('./TranscriptChat')
);

export const transcriptChatCandidateDetailChunk = createChunkLoader(
  () => import('./TranscriptChatCandidateDetail')
);
